import React from 'react'

import './Blocks/Blocks.scss'

import ControlPane from './Panels/Control'
import BlocksPane from './Panels/Blocks'

import InlineControls from './Blocks/Controls/Inline'

import Normalizer from './util/normalizer'
import DataSchema from './util/schema'

import Add from './Blocks/Add'
import Block1 from './Blocks/Block1'
import Block2 from './Blocks/Block2'
import Block3 from './Blocks/Block3'
import Block4 from './Blocks/Block4'
import Block5 from './Blocks/Block5'
import Block6 from './Blocks/Block6'
import Block7 from './Blocks/Block7'
import Block8 from './Blocks/Block8'
import { genUniqueId } from '../../../common/utils/genUniqueId'

/**
 * Вернуть нормализованные данные для блока
 */
function createBlockData(blockType, data) {
    blockType = parseInt(blockType)

    const d = {
        ...data,
        id: genUniqueId(),
        t: blockType,
    }

    switch (blockType) {
        case -1: {
            d.compName = 'Add'
            d.buttons = [
                { t: 1, text: 'Add text' },
                { t: 2, text: 'Add image' },
                { t: 4, text: 'Add Flip' },
                { t: 3, text: 'Embed Interacty project' },
            ]
            break
        }
        case 1: {
            d.text = 'Type your text here'
            break
        }
        case 2: {
            d.url = ''
            d.height = 300
            break
        }
        case 3: {
            d.embedCode = ``
            break
        }
        case 4: {
            d.frontText = '<p class="ql-align-center"><span class="ql-size-huge">Front text for edit</span></p>'
            d.frontSrc = ''
            d.frontColor = '#eee'
            d.backText = '<p class="ql-align-center"><span class="ql-size-huge">Back text</span></p>'
            d.backSrc = ''
            d.backColor = '#aaa'
            d.height = 300
            break
        }
        case 5: {
            d.embedCode = ``
            break
        }
        case 6: {
            d.text = `<p class="ql-align-center"><span class="ql-size-large" style="color: rgb(255, 255, 255);">Click</span></p>`
            d.href = `//interacty.me`
            break
        }
        case 7: {
            d.pins = []
            d.count = 3
            d.psize = 24
            d.pcl = '#2990FB'
            break
        }
        case 8: {
            d.pins = []
            d.count = 3
            d.psize = 24
            d.hpins = true
            d.pcl = '#D8D8D8'
            break
        }
        default: {
        }
    }

    return d
}

/**
 *
 * @param {*} blockType
 */
function getBlockSchema(blockType) {
    switch (blockType) {
        case 1: {
            return {
                wS_bg: {
                    // wrapper style
                    label: 'Background color',
                    type: 'string',
                    default: 'transparent',
                    control: 'ColorPicker',
                },
                text: {
                    type: 'string',
                    default: '',
                    minLength: 0,
                    maxLength: 16000,
                },
            }
        }
        case 2: {
            return {
                url: {
                    label: 'Choose Image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                blur: {
                    label: 'Interactive blur',
                    type: 'boolean',
                    default: false,
                    control: 'Checkbox',
                    hideLabel: true,
                },
            }
        }
        case 3: {
            return {
                embedCode: {
                    label: 'Embed code',
                    type: 'string',
                    default: '',
                    control: 'TextArea',
                },
            }
        }
        case 4: {
            return {
                height: {
                    label: 'Height',
                    type: 'number',
                    min: 100,
                    max: 1000,
                    default: 300,
                    control: 'TextInput',
                },
                frontSrc: {
                    label: 'Front image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                backSrc: {
                    label: 'Back image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                frontColor: {
                    label: 'Front color',
                    type: 'string',
                    default: '',
                    control: 'ColorPicker',
                },
                backColor: {
                    label: 'Back color',
                    type: 'string',
                    default: '',
                    control: 'ColorPicker',
                },
            }
        }
        case 5: {
            return {
                embedCode: {
                    label: 'Embed code',
                    type: 'string',
                    default: '',
                    control: 'TextArea',
                },
            }
        }
        case 6: {
            return {
                href: {
                    label: 'Link',
                    type: 'string',
                    default: 'https://interacty.me',
                    control: 'TextInput',
                },
                brad: {
                    label: 'Border radius',
                    type: 'number',
                    default: 4,
                    min: 0,
                    max: 99,
                    control: 'TextInput',
                },
                bc: {
                    label: 'Background color',
                    type: 'string',
                    default: '#f06666',
                    control: 'ColorPicker',
                },
            }
        }
        case 7: {
            return {
                pins: {
                    type: 'array',
                    default: [],
                },
                count: {
                    label: 'Number of tags',
                    type: 'number',
                    default: 3,
                    min: 0,
                    max: 16,
                    control: 'TextInput',
                },
                bimg: {
                    label: 'Image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                pcl: {
                    label: 'Tag color',
                    type: 'string',
                    default: '#f06666',
                    control: 'ColorPicker',
                },
                psize: {
                    label: 'Tag size',
                    type: 'number',
                    default: 24,
                    min: 4,
                    max: 50,
                    control: 'TextInput',
                },
                pimg: {
                    label: 'Tag Image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                btcolor: {
                    label: 'Button text color',
                    type: 'string',
                    default: '#fff',
                    control: 'ColorPicker',
                },
            }
        }
        case '7.pins': {
            return {
                h: {
                    label: 'Title',
                    type: 'string',
                    default: '',
                    control: 'TextInput',
                },
                d: {
                    label: 'Description',
                    type: 'string',
                    default: '',
                    control: 'TextArea',
                },
                i: {
                    label: 'Image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                blink: {
                    label: 'Button link',
                    type: 'string',
                    default: '',
                    control: 'TextInput',
                },
                btext: {
                    label: 'Button text',
                    type: 'string',
                    default: 'Ok',
                    control: 'TextInput',
                },
            }
        }
        case 8: {
            return {
                pins: {
                    type: 'array',
                    default: [],
                },
                count: {
                    label: 'Number of hidden tags',
                    type: 'number',
                    default: 3,
                    min: 0,
                    max: 16,
                    control: 'TextInput',
                },
                bimg: {
                    label: 'Image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                pcl: {
                    label: 'Tag color',
                    type: 'string',
                    default: '#f06666',
                    control: 'ColorPicker',
                },
                psize: {
                    label: 'Hidden tag size',
                    type: 'number',
                    default: 24,
                    min: 4,
                    max: 50,
                    control: 'TextInput',
                },
                btcolor: {
                    label: 'Button text color',
                    type: 'string',
                    default: '#fff',
                    control: 'ColorPicker',
                },
                suct: {
                    label: 'Final title',
                    type: 'string',
                    default: '',
                    control: 'TextInput',
                },
                sucd: {
                    label: 'Final description',
                    type: 'string',
                    default: '',
                    control: 'TextArea',
                },
                sucBlink: {
                    label: 'Final button link',
                    type: 'string',
                    default: '',
                    control: 'TextInput',
                },
                sucBtext: {
                    label: 'Final button text',
                    type: 'string',
                    default: 'Ok',
                    control: 'TextInput',
                },
            }
        }
        case '8.pins': {
            return {
                h: {
                    label: 'Title',
                    type: 'string',
                    default: '',
                    control: 'TextInput',
                },
                d: {
                    label: 'Description',
                    type: 'string',
                    default: '',
                    control: 'TextArea',
                },
                i: {
                    label: 'Image',
                    type: 'string',
                    default: '',
                    control: 'UploadButton',
                },
                blink: {
                    label: 'Button link',
                    type: 'string',
                    default: '',
                    control: 'TextInput',
                },
                btext: {
                    label: 'Button text',
                    type: 'string',
                    default: 'Ok',
                    control: 'TextInput',
                },
            }
        }
    }
}

/**
 *
 * @param {*} blockType
 */
function getBlockName(blockType) {
    switch (blockType) {
        case 1:
            return {
                value: 'Text block',
                visible: true,
            }
        case 2:
            return {
                value: 'Image',
                visible: true,
            }
        case 3:
            return {
                value: 'Interacty Project',
                visible: true,
            }
        case 4:
            return {
                value: 'Flip Card',
                visible: true,
            }
        case 5:
            return {
                value: 'Youtube video',
                visible: true,
            }
        case 6:
            return {
                value: 'Button',
                visible: true,
            }
        case 7:
            return {
                value: 'Zoom map',
                visible: true,
            }
        case 8:
            return {
                value: 'Find object',
                visible: true,
            }
        default:
            return null
    }
}

const APP_SCHEMA = {
    maxWidth: {
        label: 'Width (max)',
        type: 'number',
        default: 800,
        min: 320,
        max: 4320, // 8k
        control: 'TextInput',
    },
    bg: {
        label: 'Background color',
        type: 'string',
        default: '#fff',
        control: 'ColorPicker',
    },
}

const SUPPORTED_REMIX_BLOCKS = [1, 2, 3, 4, 5, 6, 7, 8, 9]

const Components = {
    Add,
    Block1,
    Block2,
    Block3,
    Block4,
    Block5,
    Block6,
    Block7,
    Block8,
}
/**
 *
 * @param {*} blocks
 */
function filterBlocks(blocks) {
    return blocks.filter(b => SUPPORTED_REMIX_BLOCKS.includes(b.t))
}

function normalizeBlocks(blocks) {
    return blocks.map(b => normalizeBlock(b))
}

function normalizeBlock(b) {
    for (const p in b) {
        if (Array.isArray(b[p])) {
            const pSchema = getBlockSchema(`${b.t}.${p}`)
            if (pSchema) {
                // Если задана схема типа propName.subProp для массива, то нормализуем по ней все элементы массива
                const pNorm = new Normalizer(new DataSchema(pSchema))
                b[p] = b[p].map(e => pNorm.process(e))
            }
        } else {
            // only array supported for sub property normalization
        }
    }
    const s = getBlockSchema(b.t)
    const n = new Normalizer(new DataSchema(s))
    return n.process(b)
}

function getInfo(blocks, blockId) {
    const block = blocks.find(b => b.id === blockId),
        index = blocks.indexOf(block)
    return {
        block,
        index,
    }
}

class BlockEditor extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            app: new Normalizer(new DataSchema(APP_SCHEMA)).process(props.remixAppData.app),
            blocks: normalizeBlocks([...filterBlocks(props.remixAppData.blocks)]),
            selectedBlockId: undefined,
            selectedBlockArrayProperty: {},
            openBlockPane: false,
            insertBeforeId: undefined,
        }
        this.deleteBlocksAfterAdd = null
        this.previewRef = React.createRef()
        this.onAdd = this.onAdd.bind(this)
        this.requestChangeData = this.requestChangeData.bind(this)
        this.requestChangeAppData = this.requestChangeAppData.bind(this)
        this.onPlus = this.onPlus.bind(this)
        this.onInlineControlAction = this.onInlineControlAction.bind(this)
        this.requestArrayElementControls = this.requestArrayElementControls.bind(this)
        this.history = []
        this.historyIndex = 0
        this.lastUpdate = null
    }

    onAdd(blockType, insertBeforeId, deleteAfterNextAdd) {
        if (blockType === 0) {
            this.setState({ openBlockPane: true })
        } else {
            const { blocks } = this.state

            let bb = blocks,
                block = bb.find(b => b.id === insertBeforeId),
                blockIndex = bb.indexOf(block),
                insertIndex = bb.length,
                newBlock = normalizeBlock(createBlockData(blockType))

            if (blockIndex >= 0) {
                insertIndex = blockIndex
            }
            bb.splice(insertIndex, 0, newBlock)
            if (this.deleteBlocksAfterAdd) {
                this.deleteBlocksAfterAdd.forEach(id => this.delete(id))
            }
            this.setState({
                blocks: [...bb],
            })
            if (deleteAfterNextAdd) {
                this.deleteBlocksAfterAdd = [newBlock.id]
            }
            if (blockType > 0) {
                // если был добавлен реальный блок (не служебный) то закрыть панель
                this.setState({
                    insertBeforeId: undefined,
                    openBlockPane: false,
                })
            }
        }
    }

    delete(id) {
        let bb = this.state.blocks,
            block = bb.find(b => b.id === id),
            blockIndex = bb.indexOf(block)

        if (blockIndex >= 0) {
            bb.splice(blockIndex, 1)
            this.setState({
                blocks: [...bb],
            })
        }
    }

    onInlineControlAction({ action, blockId, data }) {
        switch (action) {
            case 'delete': {
                this.delete(blockId)
                break
            }
            case 'up': {
                this.setState(prevState => {
                    const b = prevState.blocks
                    const { block, index } = getInfo(b, blockId)
                    if (index > 0) {
                        const temp = b[index - 1]
                        b[index - 1] = b[index]
                        b[index] = temp
                        return {
                            blocks: [...b],
                        }
                    }
                    return {}
                })
                break
            }
            case 'down': {
                this.setState(prevState => {
                    const b = prevState.blocks
                    const { block, index } = getInfo(b, blockId)
                    if (index < b.length - 1) {
                        const temp = b[index + 1]
                        b[index + 1] = b[index]
                        b[index] = temp
                        return {
                            blocks: [...b],
                        }
                    }
                    return {}
                })
                break
            }
        }
    }

    onDelete(evt) {
        const id = evt.currentTarget.getAttribute('dataid')
        this.delete(id)
        evt.preventDefault()
        evt.stopPropagation()
    }

    onPlus(evt) {
        const id = evt.currentTarget.getAttribute('dataid')
        this.setState({
            selectedBlockId: void 0,
            selectedBlockArrayProperty: {},
            openBlockPane: true,
            insertBeforeId: id,
        })
        evt.preventDefault()
        evt.stopPropagation()
    }

    writeHistory() {
        const s = {
            app: { ...this.state.app },
            blocks: filterBlocks(this.state.blocks),
        }
        if (this.historyIndex < 0 || this.historyIndex > this.history.length - 1) {
            this.historyIndex = this.history.length - 1
        }
        const sjson = JSON.stringify(s)
        if (sjson !== this.history[this.historyIndex]) {
            this.setState({ ...s })
            this.history = this.history.slice(0, this.historyIndex + 1)
            this.history.push(sjson)
            this.historyIndex = this.history.length - 1
        }
        this.updatePreview()
        // for debug
        window.__HISTORY__ = this.history
    }

    updatePreview() {
        if (this.props.onUpdate) {
            if (this.lastUpdate !== this.history[this.historyIndex]) {
                this.lastUpdate = this.history[this.historyIndex]
                // for debug
                window.__BLOCKS__ = this.lastUpdate
                this.props.onUpdate(this.lastUpdate)
            }
        }
    }

    onKeyDown(evt) {
        if (evt.metaKey || evt.ctrlKey) {
            const k = String.fromCharCode(evt.keyCode)
            if ((evt.shiftKey && k === 'Z') || k === 'Y') {
                this.redo()
            } else if (k === 'Z') {
                this.undo()
            }
        }
    }

    applyHistory() {
        const sjson = this.history[this.historyIndex]
        if (sjson) {
            const s = JSON.parse(sjson)
            this.setState({ ...s })
        }
    }

    redo() {
        if (this.historyIndex < this.history.length - 1) {
            this.historyIndex++
            this.applyHistory()
        }
    }

    undo() {
        // убрать текущий стейт из истории
        if (this.historyIndex > 0) {
            this.historyIndex--
            this.applyHistory()
        }
    }

    componentDidMount() {
        this.writeHistory()
        window.onkeydown = this.onKeyDown.bind(this)
    }

    componentDidUpdate() {
        this.writeHistory()
    }

    onBlockClick = evt => {
        const { selectedBlockId } = this.state

        const blockId = evt.currentTarget.getAttribute('dataid')
        if (blockId === selectedBlockId) {
            this.setState({
                selectedBlockArrayProperty: {},
            })
        } else {
            this.setState({
                selectedBlockId: blockId,
                selectedBlockArrayProperty: {},
            })
        }
    }
    onOverlayClick = evt => {
        this.setState({
            selectedBlockId: void 0,
            selectedBlockArrayProperty: {},
        })
    }

    requestChangeData(updates /* updates.id = { data, payload } */) {
        const bb = this.state.blocks
        let pleaseSetState = false

        try {
            for (const id in updates) {
                const block = bb.find(b => b.id === id),
                    index = bb.indexOf(block),
                    blockSchema = getBlockSchema(block.t),
                    data = updates[id].data,
                    payload = updates[id].payload

                let newData

                if (payload && payload.selectedBlockArrayProperty) {
                    // это запрос изменений на суб свойство, на редактирование элемента массива блока
                    const { arrName, index, schema } = payload.selectedBlockArrayProperty
                    newData = JSON.parse(JSON.stringify(block)) // глубокое клонирование надо, чтобы точно склонировать суб-свойства с которыми работаем
                    newData[arrName][index] = new Normalizer(new DataSchema(schema)).process({
                        ...newData[arrName][index],
                        ...data,
                    })
                } else {
                    // простое обновление данных блока
                    newData = { ...block, ...data }
                }

                const nb = new Normalizer(new DataSchema(blockSchema)).process(newData)
                if (JSON.stringify(bb[index]) !== JSON.stringify(nb)) {
                    bb[index] = nb
                    pleaseSetState = true
                }
            }
        } catch (err) {
            console.error(err)
        }

        if (pleaseSetState) {
            this.setState({
                blocks: [...bb],
            })
        }
    }

    /**
     * Запросить контролы для элемента в массиве
     * В блоке может быть массив, например массив точек в зум-карте.
     * Это возможность для каждой точки показать контролы при клике на нее
     *
     * @param {*} id идентификатор блока
     * @param {*} arrName имя свойства
     * @param {*} index
     */
    requestArrayElementControls(id, arrName, index) {
        const bb = this.state.blocks,
            block = bb.find(b => b.id === id),
            schema = getBlockSchema(`${block.t}.${arrName}`)

        if (schema) {
            this.setState({
                selectedBlockId: id,
                selectedBlockArrayProperty: { arrName, index, schema },
            })
        } else {
            this.setState({
                selectedBlockId: void 0,
                selectedBlockArrayProperty: {},
            })
            console.error(`Schema not found for ${block.t}.${arrName}`)
        }
    }

    requestChangeAppData(data) {
        this.setState(prev => {
            return {
                app: { ...prev.app, ...data },
            }
        })
    }

    renderEditBlock(blockData, canDelete = true, selectedBlockId) {
        const compName = blockData.compName || `Block${blockData.t}`
        if (Components[compName]) {
            let Comp = Components[compName],
                canInsert = true

            if (blockData.t === -1) {
                blockData.onAdd = this.onAdd
                canInsert = false
            }

            return (
                <div
                    key={blockData.id}
                    dataid={blockData.id}
                    className={`block-control${selectedBlockId === blockData.id ? ' __selected' : ''}${
                        blockData.t === -1 ? ' __static' : ''
                    }`}
                    onClick={this.onBlockClick}
                >
                    {blockData.t !== -1 ? <div className="selected-border"></div> : null}
                    <Comp
                        {...blockData}
                        data={this.props.data}
                        events={this.props.events}
                        onUpdate={this.requestChangeData}
                        requestArrayElementControls={this.requestArrayElementControls}
                        selected={blockData.id === this.state.selectedBlockId}
                    />
                    {canInsert && <div className="plus" dataid={blockData.id} onClick={this.onPlus}></div>}
                    {canDelete && (
                        <InlineControls onAction={this.onInlineControlAction} blockId={blockData.id}></InlineControls>
                    )}
                </div>
            )
        } else {
            console.error(`Component not defined ${compName}`)
        }
    }

    render() {
        const { selectedBlockId, selectedBlockArrayProperty, blocks, app, openBlockPane, insertBeforeId } = this.state
        const { editorRequest } = this.props
        const sBlock = selectedBlockId ? blocks.find(b => b.id === selectedBlockId) : void 0
        const t = sBlock ? sBlock.t : void 0

        return (
            <div className="artboard">
                <div className="overlay" onClick={this.onOverlayClick}></div>
                <div
                    className="block_page block_page--old"
                    style={{ width: `${app.maxWidth}px`, backgroundColor: app.bg }}
                >
                    <div>
                        {blocks.map(blockData => this.renderEditBlock(blockData, blockData.t > 0, selectedBlockId))}
                        {this.renderEditBlock(createBlockData(-1, false, selectedBlockId), false, false)}
                    </div>
                </div>
                <BlocksPane
                    open={openBlockPane}
                    onAdd={this.onAdd}
                    insertBeforeId={insertBeforeId}
                    onClose={() => this.setState({ openBlockPane: false })}
                ></BlocksPane>
                {sBlock ? (
                    <ControlPane
                        blockName={getBlockName(t)}
                        schema={getBlockSchema(t)}
                        blockData={sBlock}
                        selectedBlockArrayProperty={selectedBlockArrayProperty}
                        onUpdate={this.requestChangeData}
                        editorRequest={editorRequest}
                        isApp={false}
                    ></ControlPane>
                ) : (
                    <ControlPane
                        blockName={{
                            value: 'Project settings',
                            visible: true,
                        }}
                        schema={APP_SCHEMA}
                        blockData={app}
                        onUpdate={this.requestChangeAppData}
                        editorRequest={editorRequest}
                        isApp={true}
                    ></ControlPane>
                )}
            </div>
        )
    }
}

export default BlockEditor
